import type {GraphQLResponse} from '@/modules/common/hooks/useCampaigns/types';
import type {AxiosPromise} from 'axios';

import axios from 'axios';

export const requestCampaigns = (
  abortSignal: AbortSignal,
  travelType: string
): AxiosPromise<GraphQLResponse> => {
  return axios.post(
    import.meta.env.VITE_SERVICE_DIRECTUS_URL,
    {
      query: `query Campaigns {
        cashback_discount_campaign(
          filter: {
            status: {_eq: "published"},
            publish_date: {_lte: "$NOW"},
            expires_on: {_gte: "$NOW"},
            travel_types: {
              travelTypes_id: {
                value: {
                  _eq: "${travelType}"
                }
              }
            },
            platforms: {
              platforms_id: {
                agent: {
                  _eq: "${import.meta.env.VITE_PORTAL}"
                }
              }
            },
          }
        ) {
          cashback_title {
            cashback_discount_campaign_texts_id {
              value
              breakpoints
            }
          }
          cashback_link {
            cashback_discount_campaign_texts_id {
              value
              breakpoints
            }
          }
          discount_title {
            cashback_discount_campaign_texts_id {
              value
              breakpoints
            }
          }
          discount_button_text
          interceptor_text
          interceptor_highlight
          conditions {
            identifier
          }
          hint
          hint_tooltip
        }
        cashback_campaign(
          filter: {
            status: {_eq: "published"},
            publish_date: {_lte: "$NOW"},
            expires_on: {_gte: "$NOW"},
            travel_types: {
              travelTypes_id: {
                value: {
                  _eq: "${travelType}"
                }
              }
            },
            platforms: {
              platforms_id: {
                agent: {
                  _eq: "${import.meta.env.VITE_PORTAL}"
                }
              }
            },
          }
        ) {
          title {
            cashback_campaign_texts_id {
              value
              breakpoints
            }
          }
          subtitle {
            cashback_campaign_texts_id {
              value
              breakpoints
            }
          }
          link {
            cashback_campaign_texts_id {
              value
              breakpoints
            }
          }
          interceptor_text
          interceptor_highlight
          gradient
          conditions {
            identifier
          }
          hint
          hint_tooltip
          seasonal
          interceptor_image_small {
            filename_disk
          }
          banner_background_small {
            filename_disk
          }
          banner_background_small_size
          banner_background_small_position
          text_color
          interceptor_image_large {
            filename_disk
          }
          banner_background_large {
            filename_disk
          }
          banner_background_large_size
          banner_background_large_position
        }
        tour_operator_discount_campaign(
          filter: {
            status: {_eq: "published"},
            publishDate: {_lte: "$NOW"},
            expiresOn: {_gte: "$NOW"},
            travelTypes: {
              travelTypes_id: {
                value: {
                  _eq: "${travelType}"
                }
              }
            },
            platforms: {
              platforms_id: {
                agent: {
                  _eq: "${import.meta.env.VITE_PORTAL}"
                }
              }
            },
          }
        ) {
          hint
          hint_tooltip
          tourOperators {
            tour_operator_id {
              value
            }
          }
          titles {
            item {
              ... on tour_operator_discount_campaign_headline {
                value
                breakpoints
              }
            }
          }
          subtitles {
            item {
              ... on tour_operator_discount_campaign_headline {
                value
                breakpoints
              }
            }
          }
          interceptorContent
          interceptorContentOffers
          interceptorContentBestOffers
          filterInterceptorContent
          badgeContent
          gradient
        }
      }`,
    },
    {
      signal: abortSignal,
      validateStatus(status: number) {
        // Resolve only if the status code is 200
        return status === 200;
      },
    }
  );
};
